export default __webpack_public_path__ + "static/media/movie_profile.152f07dc.jpg";